export default __webpack_public_path__ + "static/media/avatar.90b8083f.svg";